module.exports = __webpack_public_path__ + "static/media/companies.79fb379f.svg";